import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { useAuth } from "../context/AuthContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = ({ logoUrl }) => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <header
      className="sticky top-0 z-40 border-b border-white/10 bg-[#0B1020]/70 backdrop-blur-xl"
      data-testid="site-navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" data-testid="nav-home-logo">
          <Logo src={logoUrl} />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm transition-colors ${
                  isActive ? "text-white" : "text-white/60 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          {user?.is_admin && (
            <Link
              to="/dashboard"
              data-testid="nav-dashboard-btn"
              className="rounded-full border border-white/15 px-4 py-2 text-xs font-medium text-white/80 hover:border-white/30 hover:text-white"
            >
              Dashboard
            </Link>
          )}
          <Link
            to="/contact"
            data-testid="nav-cta-btn"
            className="group relative inline-flex items-center gap-2 rounded-full px-5 py-2 text-xs font-semibold text-white"
          >
            <span className="absolute inset-0 rounded-full gradient-bg opacity-90 transition-opacity group-hover:opacity-100" />
            <span className="relative">Start a project</span>
          </Link>
        </div>

        <button
          className="md:hidden text-white/80"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 md:hidden" data-testid="nav-mobile-panel">
          <div className="flex flex-col gap-1 px-6 py-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2 text-sm ${
                    isActive ? "bg-white/5 text-white" : "text-white/70 hover:bg-white/5"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            {user?.is_admin && (
              <NavLink
                to="/dashboard"
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-white/70 hover:bg-white/5"
                data-testid="nav-mobile-link-dashboard"
              >
                Dashboard
              </NavLink>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
